import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../sos-paper-bags/Product-category-section/product-category1';
import ProductCategory2 from '../sos-paper-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../sos-paper-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../sos-paper-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../sos-paper-bags/Product-category-section/product-category5';
// import ProductCategory6 from '../sos-paper-bags/Product-category-section/product-category6';
const SOS = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid  bags-container d-flex align-items-center" >
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
          <div className="card-banner">
            <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/paper-bags/sos-bag-logo-large.jpeg"
                  className="img-fluid"
                  alt="Bag Product"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center" >
                <div className="p-4 p-lg-5 w-100">
                  <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                  Sturdy, practical, sustainable.                    </small>
                  
                  <h2 className="main-heading display-5 fw-bold text-dark mb-4">
                  Self-Opening Square Paper Bags                  </h2>
                  
                  <p className="product-each-desc text-black mb-4 lead">
                  {/* Self-Opening Square Paper Bags feature a sturdy flat base and pre-creased folds for effortless use, combining durability and versatility to meet diverse packaging needs. */}

                  SOS paper bags, also known as self-opening satchel bags, provide a practical and eco-friendly packaging solution for a wide range of business products. Made from high-quality kraft paper, these strong and durable bags are ideal for retail stores, cafes, food outlets, and pharmacies. Their unique self-opening design allows for quick, convenient packaging, and they can stand upright independently, making them easy to fill. Through our in-house design team, these bags can be customized to your specific size and branding requirements. We offer custom sizes according to customer specifications, ensuring your packaging needs are perfectly met. For convenience during trials, unexpected demand surges, or general market needs, we maintain a ready stock of unprinted bags in standard sizes.                  </p>
                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>         
      </div>
    </div>

    <ProductCategory1/>
        {/* <ProductCategory6/> */}

    <ProductCategory2/>
 
    {/* <ProductCategory3/>
     <ProductCategory4/>
    <ProductCategory5/> */}
</>
  );
};

export default SOS;